import React from 'react';
import styled from 'styled-components';

type TProps = {
    children: JSX.Element;
    outerSpacing?: {
        top: number;
        bottom: number;
    };
    textColor?: string;
};

const ComponentRow = ({ children, outerSpacing, textColor }: TProps): JSX.Element => {
    const { bottom, top } = outerSpacing || {};

    const styleProps = {
        paddingTop: top,
        paddingBottom: bottom,
        color: textColor,
    };

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <ComponentRowContainer {...styleProps}>{children}</ComponentRowContainer>;
};

type TComponentRowContainerProps = {
    paddingTop?: number;
    paddingBottom?: number;
    color?: string;
};

const ComponentRowContainer = styled.div<TComponentRowContainerProps>`
    position: relative;
    ${(props): string => (props.paddingTop ? `padding-top: ${props.paddingTop}px` : '')};
    ${(props): string => (props.paddingBottom ? `padding-bottom: ${props.paddingBottom}px` : '')};
    color: ${({ color, theme }): string => color || theme.colors.body};
`;
export default ComponentRow;
